import $axios from '@/helpers/axios-instance';

const baseUrl = process.env.API_CLASSES_URL;

export default {
  getPagedClasses(paging) {
    return $axios.get(
      `api/v1/class/page/${paging.page}/pagesize/${paging.pageSize}`,
      { baseURL: baseUrl },
    );
  },
  getClasses() {
    return $axios.get('api/v1/class', { baseURL: baseUrl });
  },
  getClassesBySchoolCode(schoolCode) {
    return $axios.get(`api/v1/class/teacher/${schoolCode}`, {
      baseURL: baseUrl,
    });
  },
  createClass(group) {
    return $axios.post('api/v1/class', group, { baseURL: baseUrl });
  },
  removeClass(id) {
    return $axios.delete(`api/v1/class/${id}`, { baseURL: baseUrl });
  },
  getStudents(group) {
    return $axios.get(`api/v1/class/${group.id}/students`, {
      baseURL: baseUrl,
    });
  },
  getStudentsById(classId) {
    return $axios.get(`api/v1/class/${classId}/students`, { baseURL: baseUrl });
  },
  getOtherStudents(group) {
    return $axios.get(`api/v1/class/${group.id}/otherstudents`, {
      baseURL: baseUrl,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/classes.js